import { styles } from 'consts';
import ringMbankIcon from 'assets/images/loader_mBank_icon.gif';

import styled from 'styled-components';

const { primaryBlack, fontMBank } = styles;

const mBankBackground =
  // tslint:disable-next-line:ter-max-len
  'PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJod…EiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+';

const NotificationContainer = styled.div`
  background-color: white;
  color: white;
  width: 100%;
  height: 100%;
  position: fixed;
  overflow-y: scroll;

  .logo {
    position: relative;
    width: 15rem;
    margin-left: 4rem;
    margin-top: 3rem;
    text-align: left;

    @media (max-width: 1024px) {
      width: 10rem;
      margin-left: 1rem;
      margin-top: 1rem;
    }

    @media (max-width: 480px) {
      width: 8rem;
      margin-left: 1rem;
      margin-top: 1rem;
    }
  }

  .outer {
    display: table;
    position: relative;
    top: 0;
    left: 0;
    height: 80%;
    width: 100%;
  }

  .middle {
    display: table-cell;
    vertical-align: middle;
    width: 100%;
  }

  .inner {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
`;

const LoaderContainer = styled.div`
  position: relative;
  width: 100%;
  height: 12rem;
  min-height: 5rem;
  max-height: 15rem;
  background: url(${ringMbankIcon}) no-repeat center center;
  background-size: contain;

  @media (max-width: 600px) {
    height: 8rem;
  }
`;

const NotificationText = styled.div`
  position: relative;
  text-align: center;
  color: ${primaryBlack};
  line-height: 1.32;
  margin: 2rem auto auto auto;
  max-width: 40rem;
  font-style: normal;
  font-size: 1.25rem;
  font-family: ${fontMBank};
  padding-left: 2rem;
  padding-right: 2rem;

  :last-child {
    padding-bottom: 1rem;
  }

  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;

const NotificationTextBold = styled(NotificationText)`
  font-weight: 700;
`;

const mBankLine = styled.div`
  // @ts-expect-error
  background: url(data:image/svg+xml;base64,${mBankBackground});
  background: -moz-linear-gradient(
          left,
          #e41e0a 0,
          #e41e0a 27%,
          #201c17 27%,
          #201c17 32%,
          #f39100 32%,
          #f39100 57%,
          #cc0b18 57%,
          #cc0b18 73%,
          #0077bd 73%,
          #0077bd 77%,
          #18a035 77%,
          #18a035 100%
  );
  background: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(0%, #e41e0a),
          color-stop(27%, #e41e0a),
          color-stop(27%, #201c17),
          color-stop(32%, #201c17),
          color-stop(32%, #f39100),
          color-stop(57%, #f39100),
          color-stop(57%, #cc0b18),
          color-stop(73%, #cc0b18),
          color-stop(73%, #0077bd),
          color-stop(77%, #0077bd),
          color-stop(77%, #18a035),
          color-stop(100%, #18a035)
  );
  background: -webkit-linear-gradient(
          left,
          #e41e0a 0,
          #e41e0a 27%,
          #201c17 27%,
          #201c17 32%,
          #f39100 32%,
          #f39100 57%,
          #cc0b18 57%,
          #cc0b18 73%,
          #0077bd 73%,
          #0077bd 77%,
          #18a035 77%,
          #18a035 100%
  );
  background: -o-linear-gradient(
          left,
          #e41e0a 0,
          #e41e0a 27%,
          #201c17 27%,
          #201c17 32%,
          #f39100 32%,
          #f39100 57%,
          #cc0b18 57%,
          #cc0b18 73%,
          #0077bd 73%,
          #0077bd 77%,
          #18a035 77%,
          #18a035 100%
  );
  background: -ms-linear-gradient(
          left,
          #e41e0a 0,
          #e41e0a 27%,
          #201c17 27%,
          #201c17 32%,
          #f39100 32%,
          #f39100 57%,
          #cc0b18 57%,
          #cc0b18 73%,
          #0077bd 73%,
          #0077bd 77%,
          #18a035 77%,
          #18a035 100%
  );
  background: linear-gradient(
          to right,
          #e41e0a 0,
          #e41e0a 27%,
          #201c17 27%,
          #201c17 32%,
          #f39100 32%,
          #f39100 57%,
          #cc0b18 57%,
          #cc0b18 73%,
          #0077bd 73%,
          #0077bd 77%,
          #18a035 77%,
          #18a035 100%
  );
`;

const LineTop = styled(mBankLine)`
  height: 0.5rem;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
`;

const LineBottom = styled(mBankLine)`
  height: 0.5rem;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  margin: 0;
`;

export { NotificationContainer, NotificationText, NotificationTextBold, LoaderContainer, LineBottom, LineTop };
